import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";

const ApproveCustomer = ({ show, closeModal, refreshPage, customerId }) => {
  const [customerCode, setCustomerCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axiosInstance.post(`/user/customer/approve_status/${customerId}`, {
        customer_code: customerCode,
        status: 'active'
      });
      
      toast.success(response.data.message);
      closeModal();
      refreshPage();
    } catch (error) {
      console.error("Error approving customer:", error);
      toast.error(error.response?.data?.message || "Failed to approve customer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={closeModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Approve Customer</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Customer Code</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter customer code"
              value={customerCode}
              onChange={(e) => setCustomerCode(e.target.value)}
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? "Approving..." : "Approve"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ApproveCustomer;